<div class="position-relative">
  <button #buttonContainer class="d-flex justify-content-center" [attr.aria-label]="ariaLabel">
  </button>
  <div *ngIf="!isClickable" class="invisible-container cursor" (click)="onClickInterrupted($event)"></div>
</div>
